import wujiFetch from '@utils/wujiFetch';
import { BASE_API_PATH } from '@config/constant';
import getXyManagePathPrefix from '@/utils/getXyManagePathPrefix';
export async function fetchProjectAiConfig(projectId, options = {}) {
    const url = options.runtime
        ? `${getXyManagePathPrefix({ envId: options.envId, isRuntimeRoute: true })}/basic/project/${projectId}/ai-config`
        : `${BASE_API_PATH}/xy/project/${projectId}/ai-config`;
    return await wujiFetch(url);
}
export async function saveProjectAiConfig(projectId, data) {
    return await wujiFetch(`${BASE_API_PATH}/xy/project/${projectId}/ai-config`, {
        method: 'PATCH',
        body: JSON.stringify(data),
    });
}
